import { render } from "./Menu.vue?vue&type=template&id=39ebc3bc&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=39ebc3bc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-39ebc3bc"

export default script